import { render, staticRenderFns } from "./snLoader.vue?vue&type=template&id=4a8eea73&scoped=true&"
import script from "./snLoader.vue?vue&type=script&lang=js&"
export * from "./snLoader.vue?vue&type=script&lang=js&"
import style0 from "./snLoader.vue?vue&type=style&index=0&id=4a8eea73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8eea73",
  null
  
)

export default component.exports